export default __webpack_public_path__ + "static/media/left-heading.png?.39f1bf70";